export * from "./Mc2EntityParam";
